export const getFlowsUsingTheme = ({ flows, steps, themeId }) => {
  const stepsWithStyle = Object.values(steps).filter(step => {
    return step.style === themeId;
  });
  // Styles are usually associated with step groups, not flows
  // Find the flow (parent) with that step
  // and deduplicate
  const flowsWithStyledChildren = {};
  stepsWithStyle.forEach(step => {
    const stepParent = step.parentId ? flows[step.parentId] : step;
    // Data gets weird when you're getting it from Firebase. Sometimes the
    // parent flow doesn't actually exist, but the step group does.
    if (stepParent) {
      flowsWithStyledChildren[stepParent.id] = stepParent;
    }
  });
  return Object.values(flowsWithStyledChildren);
};
